import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { DifferenceSection } from '../components/sales/DifferenceSection';
import { BeforeAfterSection } from '../components/sales/BeforeAfterSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { OfferSection } from '../components/sales/OfferSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalSection } from '../components/sales/FinalSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-193" data-mp="3vmi5nliu4poy">
      <header className="border-b border-brand-charcoal/10 bg-brand-paper" data-id="element-194" data-mp="3akrv1q7tia2s">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-195" data-mp="35shyhrc76brj">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-196" data-mp="30tneim2huh5u">
            Nail Educator Ready™ · Édition Française
          </p>
        </div>
      </header>

      <main data-id="element-197" data-mp="3tj44ze6jznzf">
        <HeroSection data-id="element-198" data-mp="3tiuc9iu4j2q1" />
        <InsideSection data-id="element-199" data-mp="3ti2imdk37f2e" />
        <PainSection data-id="element-200" data-mp="3tghw9b7xf2fm" />
        <SolutionSection data-id="element-201" data-mp="3ojr8s2tsl4k6" />
        <VolumesSection data-id="element-202" data-mp="3okj5jgz4l8c1" />
        <DifferenceSection data-id="element-203" data-mp="3ok1322lvdxvo" />
        <BeforeAfterSection data-id="element-204" data-mp="3ohohlfgwl5dv" />
        <BonusesSection data-id="element-205" data-mp="3jjvckprc6hf6" />
        <AudienceSection data-id="element-206" data-mp="3jj3gzexqojow" />
        <OfferSection data-id="element-207" data-mp="3jmhlaspyr2yz" />
        <FaqSection data-id="element-208" data-mp="3fitbs4hrtxb3" />
        <FinalSection data-id="element-209" data-mp="3fjkzkt54mqqt" />
      </main>

      <SiteFooter data-id="element-210" data-mp="3fijmyk8gpw6z" />
    </div>;
}